import util from '@bmp-vue/core/api/util'

const controller = 'Version'
export default Object.assign({}, util.GetCrud(controller, null))
